import React, { FC } from "react";
import { useSelector } from "react-redux";
import { ResourceTypeLink, ServiceInfoDc, ServiceListItemDc } from "@evergis/api";

import { InfoIcon } from "../../../../components/ResourceActions/InfoIcon";
import { RemoveIcon } from "../../../../components/ResourceActions/RemoveIcon";
import { SettingsIcon } from "../../../../components/ResourceActions/SettingsIcon";
import { CardIconContainer } from "../Card/styled";
import { CardControlsMenu } from "./CardControlsMenu";

import { getAnySelected, getCategory } from "../../../../ducks/catalog/selectors";
import { isEditable, isEditableType, isReadable } from "../../../../evergis/core/permissions";
import { useArcTypeService } from "../../../../hooks/layer/useArcTypeService";
import { useResourceType } from "../../../../hooks/useResourceType";

import { ResourceCategory } from "../../hooks/useFetchParams";
import { CardControlsProps } from "../../types";

export const CardControls: FC<CardControlsProps> = ({ resource, config }) => {
  const { permissions, name, alias, type, dataSourceType } = resource as ServiceListItemDc;
  const [resourceType] = useResourceType();
  const someSelected = useSelector(getAnySelected);
  const category = useSelector(getCategory(resourceType));
  const editable = isEditable(permissions);
  const readable = isReadable(permissions);
  const shareable = resourceType === ResourceTypeLink.Project;
  const isSharedResource = category === ResourceCategory.Shared;
  const isArcService = useArcTypeService(resource as Partial<ServiceInfoDc>);
  const isEditType =
    shareable ||
    (resourceType === ResourceTypeLink.Layer && isEditableType(dataSourceType)) ||
    (resourceType === ResourceTypeLink.Table && isEditableType(type));

  return (
    <CardIconContainer>
      {editable && !isSharedResource && <SettingsIcon disabled={someSelected} name={name} />}
      {(!editable || isSharedResource) && (
        <InfoIcon disabled={someSelected} title={config.infoIcon.title} name={name} />
      )}
      {editable && isEditType && !isSharedResource && <RemoveIcon disabled={someSelected} name={name} />}
      <CardControlsMenu
        resourceName={name}
        resourceAlias={alias}
        resourceType={resourceType}
        isAccessVisible={editable && !someSelected}
        isCopyVisible={readable && !(someSelected || isArcService)}
        isExportVisible={!shareable && !(someSelected || isArcService)}
      />
    </CardIconContainer>
  );
};
